import { useTranslation } from 'react-i18next';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import WarningImage from 'pos-client/assets/Avayler-Mechanic-Warning.png';
import { HttpStatusCodesEnum } from 'pos-shared/models/commonSchema.ts';
import { isEnumValue } from 'pos-shared/utils/zodHelpers.ts';

import { BoundaryError } from './BoundaryError.tsx';

interface RouterErrorProps {
  hideToolbar?: boolean;
}

export const RouterError = ({ hideToolbar }: RouterErrorProps) => {
  const { t } = useTranslation();
  const routeError = useRouteError();
  const routeErrorStatusCode = isRouteErrorResponse(routeError)
    ? (isEnumValue(`${routeError.status}`, HttpStatusCodesEnum) ??
      HttpStatusCodesEnum.enum[500])
    : HttpStatusCodesEnum.enum[500];

  const errorTitle = t(`httpStatus.${routeErrorStatusCode}`);
  const errorDescription = isRouteErrorResponse(routeError)
    ? routeError.statusText
    : undefined;
  return (
    <BoundaryError
      image={WarningImage}
      title={errorTitle}
      description={errorDescription}
      hideToolbar={hideToolbar}
    />
  );
};
